import { Box, Breakpoint, CircularProgress, Dialog, useMediaQuery, useTheme } from '@mui/material'
import React, { ReactNode } from 'react'

interface Props {
   content: ReactNode
   isLoading: boolean
   fullWidth?: boolean
   deleteVariant?: boolean
   fullScreen?: boolean
   disableClosing?: boolean
   maxWidth?: false | Breakpoint | undefined
   scroll?: 'body' | 'paper' | undefined
   open: boolean
   onClose: () => void
}

export default function CustomDialog({
   content,
   scroll,
   fullScreen,
   open,
   disableClosing,
   fullWidth,
   deleteVariant,
   maxWidth,
   isLoading,
   onClose,
}: Props) {
   const theme = useTheme()
   const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

   return (
      <Dialog
         sx={{
            '& .MuiDialogActions-root': {
               display: 'flex',
               gap: 1,
               justifyContent: 'flex-end',
               marginBottom: { lg: 0, md: 0, xs: '24px' },
               '& > button': {
                  flex: { xs: 1, md: 'unset', lg: 'unset' },
               },
            },
            '& .MuiDialogTitle-root': {
               fontSize: 20,
               padding: { lg: '10px 18px', md: '10px 18px', xs: '5px 9px' },
               color: deleteVariant ? theme.palette.error.dark : theme.palette.primary.dark,
            },
            '& .MuiDialogContent-root': {
               padding: { lg: '16px 20px', md: '16px 20px', xs: '8px 10px' },
            },
         }}
         fullWidth={fullWidth}
         fullScreen={fullScreen || isMobile}
         maxWidth={maxWidth}
         scroll={scroll}
         open={open}
         onClose={disableClosing ? undefined : onClose}
      >
         {!isLoading ? (
            content
         ) : (
            <Box
               sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: 75,
                  width: fullWidth ? '100%' : 75,
               }}
            >
               <CircularProgress />
            </Box>
         )}
      </Dialog>
   )
}
